/* 问卷管理 */
export default {
  selectQuestionnaireInfoPage: "/questionnaireInfo/selectQuestionnaireInfoPage", // 问卷列表
  insertQuestionnaireInfo: "/questionnaireInfo/insertQuestionnaireInfo", // 问卷新增
  deleteQuestionnaireInfo: "/questionnaireInfo/deleteQuestionnaireInfo", // 问卷删除
  updateQuestionnaireInfoStatus: "/questionnaireInfo/updateQuestionnaireInfoStatus", // 批量上下架
  selectQuestionnaireUser: "/questionnaireUser/selectQuestionnaireUser", // 问卷详情答题记录
  selectUserAnswer: "/questionnaireUser/selectUserAnswer", // 查看答卷
  exportQuestionnaireUser: "/questionnaireInfo/exportQuestionnaireUser", // 批量导出
}